export { default as PageNotFound } from './PageNotFound';
export { default as Layout } from './Layout';
export { default as WebLayout } from './WebLayout';



// WEBPACK FOOTER //
// ./src/features/common/index.js